import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js"; // Reused component
import Features from "../../../../Components/Features/ThreeColumnPages"; // Reused component
import {
  FaPaintBrush,
  FaUsers,
  FaHandshake,
  FaAward,
  FaMapMarkerAlt,
  FaLightbulb,
  FaChartLine,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

// Top-Rated UI/UX Services in Dubai Page Component
export const TopRatedUIUXServicesInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Top-Rated UI/UX Services in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Your Digital Success Starts Here</Subheading>}
        heading={
          <Heading>
            Elevate Your Brand with{" "}
            <span tw="text-primary-500">Top-Rated UI/UX Services in Dubai</span>
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in delivering professional UI/UX services tailored for businesses across **Dubai**. Our team combines creativity, strategy, and innovation to help you engage your audience, grow your brand, and achieve measurable results through impactful digital experiences.
          </Description>
        }
        imageSrcs={[
            "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80", // UI/UX design workspace
            "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80", // Team collaboration on design
            "https://images.unsplash.com/photo-1531403009284-440f080d1e12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80", // User experience testing
          ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get Started Today"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Your Trusted Partner for Top-Rated UI/UX Services in Dubai"
        description="We combine expertise, creativity, and innovation to deliver unmatched value."
        cards={[
          {
            icon: <FaPaintBrush color="#ff5464" size={40} />,
            title: "Creative Designs",
            description:
              "Craft visually stunning and intuitive interfaces that captivate your audience.",
          },
          {
            icon: <FaLightbulb color="#ff5464" size={40} />,
            title: "Innovative Solutions",
            description:
              "Leverage cutting-edge technologies and trends to stay ahead of the competition.",
          },
          {
            icon: <FaMapMarkerAlt color="#ff5464" size={40} />,
            title: "Localized Expertise",
            description:
              "Understand Dubai's unique market trends and diverse demographics.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "User-Centric Approach",
            description:
              "Prioritize usability, accessibility, and engagement for all users.",
          },
          {
            icon: <FaHandshake color="#ff5464" size={40} />,
            title: "Client-Centric Collaboration",
            description:
              "Work closely with you to ensure alignment with your vision and goals.",
          },
          {
            icon: <FaAward color="#ff5464" size={40} />,
            title: "Proven Track Record",
            description:
              "Delivering exceptional results for Dubai clients since [Year].",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Streamlined Process for Top-Rated UI/UX Services in Dubai"
        description={
          <Description>
            Our Dubai-focused process ensures quality, efficiency, and measurable results:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery & Research: Understand your business, audience, and goals.</li>
              <li>User Analysis: Identify your target demographic and their preferences.</li>
              <li>Wireframing & Prototyping: Create interactive prototypes for testing and feedback.</li>
              <li>Design Execution: Craft visually stunning and intuitive designs tailored for your audience.</li>
              <li>Development Integration: Collaborate with developers to bring your designs to life.</li>
              <li>Optimization & Feedback: Continuously refine designs based on user feedback and performance metrics.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
            "https://images.unsplash.com/photo-1541462608143-67571c6738dd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80", // UX wireframing process
            "https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80", // User journey mapping
            "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80", // Design review session
          ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Results That Speak for Themselves"
        description="Here’s how our UI/UX services have empowered businesses in Dubai."
        cards={[
          {
            icon: <FaAward color="#ff5464" size={40} />,
            title: "Improved User Engagement",
            description:
              "Helped an e-commerce platform in Dubai increase user retention by 150% through intuitive design.",
          },
          {
            icon: <FaHandshake color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description:
              "98% client retention rate through consistent excellence and measurable results.",
          },
          {
            icon: <FaChartLine color="#ff5464" size={40} />,
            title: "Performance Boost",
            description:
              "Achieved a 200% increase in conversions for a local retail app using optimized UX strategies.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Elevate Your Brand Experience?</Subheading>}
        heading="Let’s Build Exceptional Experiences Together in Dubai"
        description={
          <Description>
            Partner with Dubai’s leading UI/UX experts to unlock your business’s full potential. Whether you’re launching a website or mobile app, we’re here to help.
          </Description>
        }
        imageSrcs={[
            "https://images.unsplash.com/photo-1512631736742-cbacc8b7dd62?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80", // Dubai business district
            "https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80", // UI design on multiple devices
            "https://images.unsplash.com/photo-1594482628048-e43a5a7a8c97?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80", // Client meeting in modern office
          ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Today"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};